import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBannercategories } from "../services/bannercategories.service";

function BannerCategoryies() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const res = await getBannercategories();
      setCategories(res);
    };
    fetchCategories();
  }, []);

  if (!categories.length) return null;

  return (
    <ul className="list-unstyled position-absolute category-list text-uppercase">
      {categories.map((item) => (
        <li key={item.id}>
          <Link to={`/${item.action_url}`}>
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default BannerCategoryies;